// Load all the controllers within this directory and all subdirectories.
// Controller files must be named *_controller.js.

import { Application } from '@hotwired/stimulus';
const application = Application.start();
application.debug = process.env.NODE_ENV === 'development';

// Www
import AccordionController from '@sharedSrc/controllers/accordion_controller';
import CarouselController from '@sharedSrc/controllers/carousel_controller';
import DisrupterController from '@sharedSrc/controllers/disrupter_controller';
import NavigationController from '@sharedSrc/controllers/navigation_controller';
import HoverToggleClassController from './hover_toggle_class_controller';
import HighchartsController from './highcharts_controller';
import LoadController from './load_controller';
import PrintController from './print_controller';
import TextController from './text_controller';
import AnnouncementsController from '@sharedSrc/announcements_controller';
import UmbrellaFormController from './umbrella_form_controller';

import { Modal } from 'tailwindcss-stimulus-components';

// Www
application.register('accordion', AccordionController);
application.register('carousel', CarouselController);
application.register('disrupter', DisrupterController);
application.register('hover-toggle-class', HoverToggleClassController);
application.register('highcharts', HighchartsController);
application.register('navigation', NavigationController);
application.register('load', LoadController);
application.register('print', PrintController);
application.register('text', TextController);
application.register('modal', Modal);
application.register('announcements', AnnouncementsController);
application.register('umbrella-form', UmbrellaFormController);
